import { useState, useEffect } from 'react'
import is from 'is_js'
import _ from '@strings'
import { useDispatch, useSelector } from 'react-redux'
import { useGetTypes } from '@hooks'
import { setTypes, userSelectType, userSelectChild, userSelectStore } from '@store/actions/app'
import TypeSelectButton from '@components/Ui/TypeSelectButton'
import CheckBox from '@components/Form/Types/CheckBox'
import Loading from '@components/Ui/Loading'
import Spacer from '@components/Ui/Spacer'
import Text from '@components/Ui/Text'
import Error from '@components/Ui/Error'
import config from '@config'
import styles from './TypeSelect.scss'
import { userSelectSlot } from '../../../store/actions/app'

const TypeSelect = ({ setValid }) => {
  const storedTypes = useSelector((s) => s.types)
  const selectedType = useSelector((s) => s.data.type)
  const selectedChild = useSelector((s) => s.data.child)
  const [types, error, loading] = useGetTypes()
  const [selected, setSelected] = useState(selectedType)
  const [isChild, setIsChild] = useState(selectedChild)
  const dispatch = useDispatch()

  const hasStoredTypes = is.not.empty(storedTypes || [])
  const hasTypes = is.not.empty(types || [])
  const showTypes = hasStoredTypes ? storedTypes : types

  useEffect(() => {
    if (selected) {
      setValid(true)
    }
  }, [selected])

  useEffect(() => {
    if (!loading && hasTypes) {
      dispatch(setTypes(types))
    }
  }, [types, loading])

  const onClick = (type) => {
    dispatch(userSelectType(type))
    setSelected(type)
  }

  const onClickChild = () => {
    dispatch(userSelectChild(!isChild))
    setIsChild(!isChild)
  }

  return (
    <div className={styles.base}>
      {error && <Error>{_('errors.api')}</Error>}
      {loading && !hasStoredTypes && <Loading>{_('type.loading')}</Loading>}
      {showTypes && (
        <div className={styles.buttons}>
          {showTypes.map((type) => (
            <TypeSelectButton
              key={type.intId}
              onClick={() => onClick(type)}
              title={type.name}
              subtitle={type.duration}
              icon={type.icon}
              image={type.image}
              svg={type.svg}
              active={selected?.intId === type.intId}
              info={type.description}
            />
          ))}
        </div>
      )}

      {!config.get('local.hideChildren') && (
        <>
          <Spacer vertical scale="1" />
          {/*<Text type="robo_md_bold" as="div">*/}
          {/*  {_('general.paedakustik')}*/}
          {/*</Text>*/}
          {/*<Spacer vertical scale="0.5" />*/}
          <div onClick={() => onClickChild()}>
            <CheckBox
              options={[{ label: _('type.child'), value: true }]}
              value={[isChild ? true : null]}
            />
          </div>
        </>
      )}
    </div>
  )
}

TypeSelect.defaultProps = {
  setValid: () => {},
}
TypeSelect.propTypes = {}

export default TypeSelect
